import { cn } from '@/lib/cn';

/**
 * §11: "loading (skeleton, never a spinner on lists)".
 *
 * A spinner tells a buyer on a slow Nigerian connection that something is
 * happening. A skeleton tells them WHAT is coming and how much of it, which is
 * the difference between waiting and wondering whether to reload.
 */

export interface SkeletonProps {
  className?: string;
  /** Rounded like the thing it stands in for. */
  radius?: 'sm' | 'md' | 'card' | 'pill' | 'none';
}

const radii = {
  sm: 'rounded',
  md: 'rounded-lg',
  card: 'rounded-card',
  pill: 'rounded-pill',
  none: '',
} as const;

export function Skeleton({ className, radius = 'sm' }: SkeletonProps) {
  return <div aria-hidden data-skeleton className={cn('skeleton', radii[radius], className)} />;
}

/** A block of text lines, the last one short, as real paragraphs are. */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('space-y-2', className)} aria-hidden>
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton
          key={index}
          className={cn('h-2.5', index === lines - 1 ? 'w-[45%]' : 'w-full')}
        />
      ))}
    </div>
  );
}
